export default __webpack_public_path__ + "static/media/watch.56aa3e36.svg";